import CargoCompanyOrderBillingsListResponse, {
  CargoCompanyOrderBillingsListResponseDataItem,
  CargoCompanyOrderBillingsListResponseDataItemBillingNodes,
  CargoCompanyOrderBillingsListResponseDataItemBillingType,
} from "../../../../api/raily/cargo-company/order-billings/list/cargo-company-order-billings-list.response";
import BillingType from "../../../../types/billing-type";
import CargoCompanyOrderBillingsList, {
  CargoCompanyOrderBillingsListItem,
  CargoCompanyOrderBillingsListItemBillingNodes,
} from "./cargo-company-order-billings-list";

const createDataItemBillingType = (
  billingType: CargoCompanyOrderBillingsListResponseDataItemBillingType,
): BillingType => {
  switch (billingType) {
    case CargoCompanyOrderBillingsListResponseDataItemBillingType.PRIV_CARGO_2_TAXI:
      return BillingType.PRIV_CARGO_2_TAXI;
    case CargoCompanyOrderBillingsListResponseDataItemBillingType.PUB_CARGO_2_RAILY:
      return BillingType.PUB_CARGO_2_RAILY;
  }
};

const createDataItemBillingNodesItem = (
  item: CargoCompanyOrderBillingsListResponseDataItemBillingNodes,
): CargoCompanyOrderBillingsListItemBillingNodes => {
  return {
    description: item.description,
  };
};

const createDataItemBillingNodes = (
  billingNodes: CargoCompanyOrderBillingsListResponseDataItemBillingNodes[],
): CargoCompanyOrderBillingsListItemBillingNodes[] => {
  return billingNodes.map(createDataItemBillingNodesItem);
};

const createDataItem = (
  item: CargoCompanyOrderBillingsListResponseDataItem,
): CargoCompanyOrderBillingsListItem => {
  return {
    allContributionsAmount: item.allContributionsAmount,
    amountForChargeHaltings: item.amountForChargeHaltings,
    amountForChargeHighways: item.amountForChargeHighways,
    amountForDistance: item.amountForDistance,
    baseDistanceRate: item.baseDistanceRate,
    billingNodes: createDataItemBillingNodes(item.billingNodes),
    billingType: createDataItemBillingType(item.billingType),
    contractCorrectionPercentage: item.contractCorrectionPercentage,
    date: item.date,
    dispatch: item.dispatch,
    distance: item.distance,
    externalId: item.externalId,
    hoursOfHaltings: item.hoursOfHaltings,
    humanId: item.humanId,
    id: item.id,
    passengers: item.passengers,
    status: item.status,
    sumOfDiscounts: item.sumOfDiscounts,
    taxiCorporation: item.taxiCorporation,
  };
};

const createData = (
  data: CargoCompanyOrderBillingsListResponseDataItem[],
): CargoCompanyOrderBillingsListItem[] => {
  return data.map(createDataItem);
};

const create = (
  response: CargoCompanyOrderBillingsListResponse,
): CargoCompanyOrderBillingsList => {
  return {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };
};

const cargoCompanyOrderBillingsListFactory = {
  create,
};

export default cargoCompanyOrderBillingsListFactory;
